import type { RecordEffect } from "@/features/patient/records/api/dataPipelineApi";
import type { ReviewOutcome } from "@/portals/patient/api/reviewItemsApi";

/** What the physician decided, in the patient's words. Pair and single items read differently. */
export function outcomeActionLabel(action: ReviewOutcome["action"], isPair: boolean): string {
  switch (action) {
    case "KEEP_EXISTING":
      return isPair ? "Your physician kept your earlier record" : "Your physician confirmed this record";
    case "ACCEPT_NEW":
      return "Your physician accepted your newer record";
    case "BOTH_VALID":
      return "Your physician confirmed both records";
    case "MARK_DISCONTINUED":
      return isPair ? "Your physician marked one medicine as discontinued" : "Your physician marked this medicine as discontinued";
    case "CORRECT_VALUE":
      return "Your physician corrected your record";
    case "REJECT_BOTH":
      return isPair ? "Your physician removed these records" : "Your physician removed this record";
  }
}

export const EFFECT_LABELS: Record<RecordEffect, string> = {
  KEPT: "Kept",
  DISMISSED: "Removed from your list",
  DISCONTINUED: "Marked as discontinued",
  CORRECTED: "Corrected",
};
